import React from "react";
import {
  SectionHeading,
  ContentSection,
  Paragraph,
} from "@vwfs-bronson/bronson-react";
import { Output } from "../../Text";

class DataProtectionPage extends React.Component {
  BRAND = process.env.REACT_APP_BRAND;
  Text = require(`../../Text/${this.BRAND}/translations.json`);

  renderTitle(section: any) {
    return (
      <Paragraph>
        <strong>{section.title}</strong>
      </Paragraph>
    );
  }

  renderTextBeforeList(section: any) {
    return section?.textsBeforelist?.map((textBeforeList: any) => (
      <Paragraph
        dangerouslySetInnerHTML={{ __html: textBeforeList.text }}
      ></Paragraph>
    ));
  }

  renderList(section: any) {
    return (
      <Paragraph>
        <ul>
          {section?.list?.map((listItem: any) => (
            <li dangerouslySetInnerHTML={{ __html: listItem.text }}></li>
          ))}
        </ul>
      </Paragraph>
    );
  }

  renderTextsAfterList(section: any) {
    return section?.textsAfterlist?.map((textAfterlist: any) => (
      <Paragraph
        dangerouslySetInnerHTML={{ __html: textAfterlist.text }}
      ></Paragraph>
    ));
  }
  renderDataprotection() {
    return (
      <>
        {this.Text.pages.leasing.dataProtection.sections.map((section: any) => (
          <>
            <React.Fragment>{this.renderTitle(section)}</React.Fragment>
            <React.Fragment>
              {this.renderTextBeforeList(section)}
            </React.Fragment>
            <React.Fragment>{this.renderList(section)}</React.Fragment>
            <React.Fragment>
              {this.renderTextsAfterList(section)}
            </React.Fragment>
          </>
        ))}
      </>
    );
  }

  render() {
    return (
      <ContentSection pageWrap pageWrapSize="medium">
        <SectionHeading level="3" center>
          {Output.resolve("pages.leasing.dataProtection.title")}
        </SectionHeading>
        <Paragraph>
          {Output.resolve("pages.leasing.dataProtection.headerText")}
        </Paragraph>
        {this.renderDataprotection()}
      </ContentSection>
    );
  }
}

export { DataProtectionPage };
